import { changeHotel } from 'actions/hotel';

import { lanMapRoute, changeLng } from 'util/i18n';

export default store => ({
	path: 'privacy',
	onEnter: () => {
		const { hotel: { hotel } } = store.getState();

		if (hotel !== 'main') {
			store.dispatch(changeHotel('main'));
		}
	},
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'Privacy',
			),
	},
	childRoutes: [
		{
			path: ':lang',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./component').default;
							cb(null, component);
						},
						'Privacy',
					),
			},
			onEnter: ({ params: { lang } }) => {
				const { global: { lan } } = store.getState();

				if (lanMapRoute(lan) !== lang) {
					changeLng(lang);
				}
			},
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Privacy/index.js